import React, {useCallback} from "react"
import * as styles from "./videoTiles.module.css"
import LiteYouTubeEmbed from "react-lite-youtube-embed"
import "../styles/youtubeEmbeds.css"
import {sendGAPageview} from "../utils/analytics"

interface Video {
	id: string
	title: string
}

interface VideoTilesProps {
	videos: Array<Video>
	useFacade?: boolean
}

export default function VideoTiles({videos, useFacade}: VideoTilesProps) {
	const handleIframeAdded = useCallback(
		(videoId: string, videoTitle: string) => {
			sendGAPageview(
				`YouTube Video: ${videoTitle}`,
				`/home/play-youtube-${videoId}`
			)
		},
		[]
	)

	return (
		<div>
			<ul className={styles.videos}>
				{videos.map((video, index) => (
					<li key={video.id || index}>
						<div className={styles.videoWrapper}>
							{useFacade ? (
								<>
									<span className={styles.videoTitle}>{video.title}</span>
									<LiteYouTubeEmbed
										id={video.id}
										params="rel=0"
										title={video.title}
										onIframeAdded={() =>
											handleIframeAdded(video.id, video.title)
										}
									/>
								</>
							) : (
								<iframe
									id={`youtube-${video.id}`}
									src={`https://www.youtube.com/embed/${video.id}?rel=0&enablejsapi=1`}
									title={`YouTube video player: ${video.title}`}
									allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
									loading="lazy"
									scrolling="no"
									frameBorder="0"
									allowFullScreen
								/>
							)}
						</div>
					</li>
				))}
			</ul>
		</div>
	)
}
